import Balcony from "../assets/img/rooms/Balcony.png";
import BathRoom from "../assets/img/rooms/BathRoom.png";
import BedRoom from "../assets/img/rooms/BedRoom.png";
import BedRoom2 from "../assets/img/rooms/BedRoom.png";
import BedRoom3 from "../assets/img/rooms/BedRoom.png";
import BedRoom4 from "../assets/img/rooms/BedRoom.png";
import Cave from "../assets/img/rooms/Cave.png";
import Cellar from "../assets/img/rooms/Cellar.png";
import cleaned from "../assets/img/rooms/cleaned.png";
import cleanings from "../assets/img/rooms/cleanings.png";
import Clearance from "../assets/img/rooms/Clearance.png";
import coldWater from "../assets/img/rooms/coldWater.png";
import Corridor from "../assets/img/rooms/Corridor.png";
import Dressing from "../assets/img/rooms/Dressing.png";
import dust from "../assets/img/rooms/dust.png";
import electricity from "../assets/img/rooms/electricity.png";
import EntranceHall from "../assets/img/rooms/EntranceHall.png";
import GameRoom from "../assets/img/rooms/GameRoom.png";
import Garage from "../assets/img/rooms/Garage.png";
import gas from "../assets/img/rooms/gas.png";
import grease from "../assets/img/rooms/grease.png";
import heater from "../assets/img/rooms/heater.png";
import hotWater from "../assets/img/rooms/hotWater.png";
import IndoorWC from "../assets/img/rooms/IndoorWC.png";
import InventoryEquipment from "../assets/img/rooms/InventoryEquipment.png";
import InventoryKeys from "../assets/img/rooms/InventoryKeys.png";
import InventoryOutside from "../assets/img/rooms/InventoryOutside.png";
import key from "../assets/img/rooms/key.png";
import Kitchen from "../assets/img/rooms/Kitchen.png";
import LaundryRoom from "../assets/img/rooms/LaundryRoom.png";
import LivingRoom from "../assets/img/rooms/LivingRoom.png";
import Loggia from "../assets/img/rooms/Loggia.png";
import Office from "../assets/img/rooms/Office.png";
import Saloon from "../assets/img/rooms/Saloon.png";
import Stay from "../assets/img/rooms/Stay.png";
import Terrace from "../assets/img/rooms/Terrace.png";
import uncleaned from "../assets/img/rooms/uncleaned.png";
import walls from "../assets/img/rooms/walls.png";
import WaterRoom from "../assets/img/rooms/WaterRoom.png";
import WC from "../assets/img/rooms/WC.png";
import WineCellar from "../assets/img/rooms/WineCellar.png";

interface IconMappings {
  [key: string]: string;
}

export const iconRoomMapping: IconMappings = {
  InventoryOutside,
  Balcony,
  BathRoom,
  BedRoom,
  BedRoom2,
  BedRoom3,
  BedRoom4,
  Cave,
  Cellar,
  cleaned,
  cleanings,
  Clearance,
  coldWater,
  Corridor,
  Dressing,
  dust,
  Garage,
  electricity,
  EntranceHall,
  GameRoom,
  gas,
  grease,
  heater,
  hotWater,
  IndoorWC,
  key,
  InventoryKeys,
  InventoryEquipment,
  Kitchen,
  LaundryRoom,
  LivingRoom,
  Loggia,
  Office,
  Saloon,
  Stay,
  Terrace,
  uncleaned,
  walls,
  WaterRoom,
  WC,
  WineCellar,
};
